import consumer from "./consumer"

function updateBracketNumber(accountNumber) {
  try {
    // Find the <td> element with the specified class and account number
    var $tdElement = $('td.grouped-checkbox-late[data-account-number="' + accountNumber + '"]');
    // Check if the element exists
    if ($tdElement.length === 0) {
      console.warn('No element found for account number:', accountNumber);
      return; // Exit if no matching element is found
    }
    // Get the current text of the element
    var currentText = $tdElement.text();
    // Use a regular expression to find the number inside parentheses
    var updatedText = currentText.replace(/\((\d+)\)/, function(match, number) {
      // Reduce the number by 1
      var newNumber = parseInt(number) - 1;
      // Ensure the number doesn't go negative
      if (newNumber < 0) {
        console.warn('Number inside parentheses cannot be negative.');
        return match; // Return the original match to avoid changes
      }
      // Return the updated value with parentheses
      return '(' + newNumber + ')';
    });
    // Update the element with the new text
    $tdElement.text(updatedText);
  } catch (error) {
    console.error('An error occurred while updating the element:', error);
  }
}

consumer.subscriptions.create("ImportsChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("Connected to import channel !!!");
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    if (data.status === "success") {
      $('.upload-status').append(data.content + "<br />");
    } else if(data.status === "auto_refund_success"){
      $('#auto-status-bar').text(data.content);
      $('body').css('cursor', 'progress');
    } else if(data.status === "auto_refund_completion"){
      $('#auto-status-bar').text(data.content);
      $('body').css('cursor', 'pointer');
    } else if(data.status === "auto_refund_waiting"){
      $('#auto-status-bar').text('');
      startCountDown();
    } else if (data.status === "error") {
      $('.upload-status').append(data.content + ' ' + data.error + "<br />");
    } else if (data.status === "finished") {
      $('.upload-status').append(data.content + "<br />");
    } else if (data.status === "complete") {
      $('.upload-status').append(data.content + "<br />");
      $('.refund-btn').removeAttr('disabled');
    } else if (data.status === "batch_tracking") { 
      if($('.upload-status').find('#account-detail-div').length <= 0) {
        $('.upload-status').append('<p id="account-detail-div"></p>');
      }
      if($('.upload-status').find('#batch-track-table').length <= 0) {
        $('.upload-status').append('<table class="table" id="batch-track-table"></table>');
      }
      $('#account-detail-div').html("Tracking packages for customer <b>" + data.account_name + "</b>");
      $('#batch-track-table').html(data.content);
    } else if(data.status === "ups_refunds_update") {
      var refund_counter = $('#refunds-ctr').text();
      var total_counter = $('#account-late-datatable_info').text();
      refund_counter = parseInt(refund_counter) + 1;
      total_counter = total_counter.replace("Total: ","");
      total_counter = parseInt(total_counter) - 1;
      $('#refunds-ctr').html(refund_counter);
      $('#' + data.tracking_number).parent().parent().remove();
      $('#account-late-datatable_info').text("Total: " + total_counter);
      updateBracketNumber(data.account_number);
    } else if(data.status === "ups_denied_update") {
      var denied_counter = $('#denied-ctr').text();
      var total_counter = $('#account-late-datatable_info').text();
      denied_counter = parseInt(denied_counter) + 1;
      total_counter = total_counter.replace("Total: ","");
      total_counter = parseInt(total_counter) - 1;
      $('#denied-ctr').html(denied_counter);
      $('#' + data.tracking_number).parent().parent().remove();
      $('#account-late-datatable_info').text("Total: " + total_counter);
      updateBracketNumber(data.account_number);
    } else if(data.status === "exception_update") {
      var exceptions_ctr = $('#exceptions-ctr').text();
      var total_counter = $('#account-late-datatable_info').text();
      exceptions_ctr = parseInt(exceptions_ctr) + 1;
      total_counter = total_counter.replace("Total: ","");
      total_counter = parseInt(total_counter) - 1;
      $('#exceptions-ctr').html(exceptions_ctr);
      $('#' + data.tracking_number).parent().parent().remove();
      $('#account-late-datatable_info').text("Total: " + total_counter);
    } else if(data.status === "pending_delivery_starts") {
      $('#pending-delivery-status-bar').text(data.content);
    } else if(data.status === "pending_delivery_ends") {
      $('#pending-delivery-status-bar').text(data.content);
    } else if(data.status === "fbo_check") {
      var fbo_counter = $('#fbo-ctr').text();
      fbo_counter = parseInt(fbo_counter) + 1;
      $('#fbo-ctr').html(fbo_counter);
    } else if(data.status === "verify_refunds_update") {
      console.log("In verify_refunds_update");
      var refundId = data.refund_id;
      var refund_amt = data.refund_amount;
      $('#refund-' + refundId +'-total-refund-amount').val(refund_amt);
      var ptr = $('#refund-' + refundId +'-total-refund-amount').parents('tr');
      if(ptr.prev().data('name') === data.invoice_number) {
        ptr.prev().empty().remove();
      }
      ptr.empty().remove();
    } else if (data.status === "verified_batch_refunds") {
      var verifiedCounter = $('#verified-refunds-status').data('count') || 0;
      verifiedCounter += 1;
      $('#verified-refunds-status').data('count', verifiedCounter);
      var verifiedContent = `${data.tracking_number}<br/>`;
      $('#verified-refunds-status').html(`Verified Refunds: ${verifiedCounter}`);
      $('#verified-refunds-div').append(verifiedContent);
    } else if (data.status === "unverified_batch_refunds") {
      var unverifiedCounter = $('#unverified-refunds-status').data('count') || 0;
      unverifiedCounter += 1;
      $('#unverified-refunds-status').data('count', unverifiedCounter);
      var unverifiedContent = `${data.tracking_number}<br/>`;
      $('#unverified-refunds-status').html(`Unverified Refunds: ${unverifiedCounter}`);
      $('#unverified-refunds-div').append(unverifiedContent);
    }
    // Able to re-download
    $('.auto-download-btn').removeAttr('disabled');
  }
});
